export default () => {
    function onlyNumber($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
            $event.preventDefault();
        }
    }

    function makeSlug(str) {
        return str.trim()
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function $t(str) {
        return Lang.get(str)
    }

    function setLang(lang) {
        Lang.setLocale(lang)
    }

    function capitalize(word) {
        const lower = word.toLowerCase();
        return word.charAt(0).toUpperCase() + lower.slice(1);
    }

    function dateOrdinalSuffix(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }

    function calculatePaymentGatewayFee(paymentGateway, total) {
        let percentage = 0;
        let fixed = 0;
        let feeDescription = '';

        if (paymentGateway.percentage != null || paymentGateway.fixed_amount != null) {
            percentage = parseFloat(paymentGateway.percentage) || 0;
            fixed = parseFloat(paymentGateway.fixed_amount) || 0;
        } else if (paymentGateway.fee_type === 'percentage') {
            percentage = parseFloat(paymentGateway.fee) || 0;
        } else {
            fixed = parseFloat(paymentGateway.fee) || 0;
        }

        // Mirrors PaymentGatewayFee.php.
        const totalCents = Math.round(total * 100);
        const percentageCents = percentage > 0 ? Math.floor((totalCents * Math.round(percentage * 10000) + 500000) / 1000000) : 0;
        const fixedCents = fixed > 0 ? Math.round(fixed * 100) : 0;
        const totalFee = ((percentageCents + fixedCents) / 100).toFixed(2);

        if (parseFloat(paymentGateway.percentage) > 0 && parseFloat(paymentGateway.fixed_amount) > 0) {
            feeDescription = ` (${paymentGateway.percentage}% + RM${parseFloat(paymentGateway.fixed_amount).toFixed(2)})`;
        } else if (parseFloat(paymentGateway.percentage) > 0) {
            feeDescription = ` (${paymentGateway.percentage}%)`;
        } else if (paymentGateway.fee_type === 'percentage' && !paymentGateway.hasOwnProperty('percentage')) {
            feeDescription = ` (${paymentGateway.fee}%)`;
        }

        return {
            value: totalFee,
            display: 'RM' + totalFee + feeDescription
        };
    }

    return { onlyNumber, makeSlug, $t, setLang, capitalize, dateOrdinalSuffix, calculatePaymentGatewayFee }
}
